/********************************************* ASSETS *********************************************/
const s = require('./blue-button.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {isStringOrNumber} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import {SubmitButton} from '@canimmunize/core-imports';

/********************************************* EXPORT *********************************************/
/**
 * Simplified wrapper around SubmitButton to create a deep-blue button for
 * special cases requiring a deeper blue colour than the default, no default
 * width, and only a small number of properties
 */
export const BlueButton = (props: {
    title: string;
    onClick: EventHandler;
    id?: string;
    className?: string;
    width?: number | string;
    widthClass?: string;
}) => (
    <SubmitButton
        id={props.id || null}
        bgColor={cn(`bg-blue bg-mid-dark-blue-hover bg-dark-blue-active`)}
        mergeClasses={cn(s[`blue-button`], props.className)}
        onClick={props.onClick}
        ariaLabel={props.title}
        width={isStringOrNumber(props.width) ? props.width : false}
        widthClass={props.widthClass}
    >
        <span className={cn(`fw-500 helvetica-neue wk-smoothen-text`, props.className)}>
            {props.title}
        </span>
    </SubmitButton>
);
